var lib_core = require("lib-core");

var UploadStateMachine = function (root) {
    var self = this;

    this.root = root;

    lib_core.StateMachine.call(self);

    // this should be in a view...
    this.createInput();
    ////////

    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.UI_UPLOAD_PRESSED;
        },
        function(cEvent){
            self.showFileSelectWindow();
        }
    );
};

lib_core.inherit(UploadStateMachine, lib_core.StateMachine);

UploadStateMachine.prototype.showFileSelectWindow = function() {
    this.input.click(); // opening dialog
}

UploadStateMachine.prototype.createInput = function() {
    var self = this;
    if(this.input) this.input.remove();
    this.input = $(document.createElement('input'));
    this.input.attr("type", "file");
    this.input.attr("accept", self.getFileTypes());
    this.input.attr("multiple", "multiple");
    this.input.change(function(){
        self.consumeFiles(this.files);
        self.createInput();
    });
}

// what file types to accept
UploadStateMachine.prototype.getFileTypes = function(){
    console.error("not implimented");
    return '.txt';
}

// what to do with the files
UploadStateMachine.prototype.consumeFile = function(fileData) {
    console.error("not implimented");
}

UploadStateMachine.prototype.consumeFiles = function(array) {
    console.error("not implimented");
}



module.exports = UploadStateMachine;